import React from 'react';
import './AppSection.css';

const AppSection = () => (
  <section className="app-sec" id="app">
    <div className="container">
      <div className="app-inner">
        <div className="reveal">
          <span className="sec-label">Mobile-first</span>
          <h2 className="sec-h2">GoSnap Is<br /><em>In Your Pocket</em></h2>
          <p className="sec-p">
            Book, track and receive content from your phone. The GoSnap app makes professional video creation as easy as ordering food.
          </p>
          <h2 className="sec-h2">Coming Soon.</h2>
          <div className="app-badges">
            <a href="#" className="app-badge">
              <svg viewBox="0 0 24 24">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
              </svg>
              <div>
                <div className="app-badge-sm">Download on the</div>
                <div className="app-badge-lg">App Store</div>
              </div>
            </a>
            <a href="#" className="app-badge">
              <svg viewBox="0 0 24 24">
                <path d="M3.18 23.76c.3.17.64.22.99.13l12.6-7.29-2.61-2.61-10.98 9.77zm-1.83-20.4C1.12 3.71 1 4.08 1 4.56v14.88c0 .48.12.85.35 1.2l.07.06 8.34-8.34v-.18L1.35 3.3l-.01.06zM20.43 10.3l-2.4-1.38-2.93 2.93 2.93 2.93 2.43-1.4c.69-.4.69-1.06-.03-1.47v-.01zM4.17.25L16.77 7.54l-2.61 2.61L3.18.37c.3-.18.66-.21.99-.12z" />
              </svg>
              <div>
                <div className="app-badge-sm">Get it on</div>
                <div className="app-badge-lg">Google Play</div>
              </div>
            </a>
          </div>
        </div>
        <div className="app-visual reveal rd1">
          <div className="app-phone-wrap">
            <div className="app-phone">
              <div className="ph-notch" />
              <div className="app-screen-content">
                <div className="app-screen-header">
                  <div className="app-screen-logo"><em>Go</em>Snap</div>
                  <div className="app-screen-notif">🔔</div>
                </div>
                <div className="app-booking-card">
                  <div className="app-booking-label">Active Booking</div>
                  <div className="app-booking-name">🎥 Kiran Naidu</div>
                  <div className="app-booking-status">
                    <span className="status-dot" /> En route · ETA 12 min
                  </div>
                  <div className="app-booking-progress">
                    <div className="progress-fill" />
                  </div>
                </div>
                <div className="app-quick-actions">
                  <div className="qa-btn">📅 Reschedule</div>
                  <div className="qa-btn">💬 Message</div>
                </div>
                <div className="app-reel-preview">
                  <div className="reel-thumb">🎬</div>
                  <div>
                    <div className="reel-title">Your last reel</div>
                    <div className="reel-views">👁 42.6K views</div>
                  </div>
                  <div className="reel-badge">VIRAL</div>
                </div>
              </div>
            </div>
          </div>
          <div className="app-deco-ring" />
        </div>
      </div>
    </div>
  </section>
);

export default AppSection;
